:host {
  --default-bar-color: var(--chart-100-pressed);
  --default-thumb-color: var(--grey-layout-200-disabled);
  --hover-bar-color: var(--chart-301-icon-buttons);
  --checked-bar-color: var(--blue-layout-203-disabled);
  --disabled-bar-color: var(--chart-050-hover);
  --disabled-thumb-color: var(--chart-100-pressed);
  --disabled-checked-bar-color: var(--blue-layout-103-background);
  --disabled-checked-thumb-color: var(--blue-layout-203-disabled);
  --margin-vertical: 15px;
  --label-font-family: var(--font-family-secondary);
  --label-font-size: var(--body-size-large);
  height: auto;
  box-sizing: border-box;
  display: block;
  width: 100%;
  --label-padding-left: var(--spacer);
}

:host([smallSize]) {
  .toggle-bar {
    width: 32px;
    height: 10px;
    .toggle-thumb {
      width: 16px;
      height: 16px;
    }
    input:checked + .toggle-thumb {
      transform: translate3d(17px, 0, 0);
    }
  }
}

.toggle-button {
  display: flex;
  margin: var(--margin-vertical) 0;
  cursor: pointer;
  align-items: center;

  input {
    border: 0;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    outline: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .toggle-bar {
    position: relative;
    width: 34px;
    height: 14px;
    flex-shrink: 0;
    border-radius: 8px;
    background-color: var(--default-bar-color);

    .toggle-thumb {
      position: absolute;
      z-index: 1;
      width: 20px;
      height: 20px;
      top: -3px;
      left: 0;
      border-radius: 50%;
      background-color: var(--white-layout-301-level-0-elevation);
      transform: translate3d(0, 0, 0);
      transition: all 80ms linear;
      transition-property: transform;
      box-shadow: 0 2px 1px #0000001f;
      &:after {
        content: "";
        position: absolute;
        background: var(--default-thumb-color);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        z-index: -1;
      }
    }

    input:checked + .toggle-thumb {
      transform: translate3d(14px, 0, 0);
    }
  }

  &:hover {
    .toggle-bar {
      .toggle-thumb {
        &:after {
          background-color: var(--hover-bar-color);
        }
      }
    }
  }

  &:active {
    .toggle-bar {
      .toggle-thumb {
        &:after {
          background-color: var(--blue-layout-300-active);
        }
      }
    }
  }

  .toggle-label {
    font-size: var(--label-font-size);
    font-family: var(--label-font-family);
    line-height: 1.4;
    padding-left: var(--label-padding-left);
    color: var(--main-titles-inputs-600);
  }
}

:host([checked]) {
  .toggle-button {
    .toggle-bar {
      background-color: var(--checked-bar-color);

      .toggle-thumb {
        &:after {
          background-color: var(--blue-layout-402-primary-background);
        }
      }
    }

    &:hover {
      .toggle-bar {
        .toggle-thumb {
          &:after {
            background-color: var(--blue-layout-300-active);
          }
        }
      }
    }

    &:active {
      .toggle-bar {
        .toggle-thumb {
          &:after {
            background-color: var(--blue-layout-301-active);
          }
        }
      }
    }
  }
}

:host([disabled]) {
  pointer-events: none;
}

:host([disabled]),
:host([readonly]) {
  .toggle-button {
    cursor: default;

    .toggle-label {
      color: var(--grey-layout-200-disabled);
    }
  }

  .toggle-bar {
    background-color: var(--disabled-bar-color);

    .toggle-thumb {
      &:after {
        background-color: var(--disabled-thumb-color);
      }
    }
  }

  &:host([checked]) {
    .toggle-bar {
      background-color: var(--disabled-checked-bar-color);

      .toggle-thumb {
        &:after {
          background-color: var(--disabled-checked-thumb-color);
        }
      }
    }
  }
}

:host([readonly]) {
  pointer-events: none;

  .toggle-button {
    cursor: default;
  }

  .toggle-bar {
    background-color: var(--disabled-bar-color);

    .toggle-thumb {
      &:after {
        background-color: var(--disabled-thumb-color);
      }
    }
  }

  &:host([checked]) {
    .toggle-bar {
      background-color: var(--disabled-checked-bar-color);

      .toggle-thumb {
        &:after {
          background-color: var(--disabled-checked-thumb-color);
        }
      }
    }
  }
}
